// extracted by mini-css-extract-plugin
module.exports = {"video":"video-player_video__8GR5s","dropShadow":"video-player_dropShadow__muUJq"};